window.theme = window.theme || {};
var Thm = {
  init: function () {
    this.Basic.init();
  },
  Basic: {
    init: function () {
      this.smoothScroll();
      this.marqueeScroller();
  
    },
    smoothScroll: function () {
      document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"]):not([href="#recover"]):not([href="#login"])').forEach(a => {
        a.addEventListener('click', function (e) {
          if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            var target = document.querySelector(this.hash) || document.querySelector('[name=' + this.hash.slice(1) + ']');
            if (target) {
              e.preventDefault();
              window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
              setTimeout(() => {
                target.focus();
                if (!target.matches(':focus')) {
                  target.setAttribute('tabindex', '-1');
                  target.focus();
                }
              }, 600);
            }
          }
        });
      });

    },
    marqueeScroller: function () {
      if (!customElements.get("marquee-content")) {
        class Marquee extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          calculationPaddingSection() {
            (this.heightSection = this.offsetHeight),
              (this.heightSection =
                this.heightSection < 18
                  ? 18
                  : 96 < this.heightSection
                    ? 96
                    : this.heightSection),
              this.closest(".js-running-content").style.setProperty(
                "--spacing-padding-block",
                this.heightSection + "px"
              );
          }
          init() {
            (this.distance =
              this.querySelector(".js-marquee-item").offsetWidth),
              (this.speed = this.dataset.speed),
              this.style.setProperty(
                "--marquee-duration",
                this.distance / this.speed + "s"
              );
          }
        }
        customElements.define("marquee-content", Marquee);
      }
    },
 
  },
};


document.addEventListener('DOMContentLoaded', function () {
  Thm.init();
});



if (!customElements.get("marquee-content")) {
  class Marquee extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    calculationPaddingSection() {
      (this.heightSection = this.offsetHeight),
        (this.heightSection =
          this.heightSection < 18
            ? 18
            : 96 < this.heightSection
              ? 96
              : this.heightSection),
        this.closest(".js-running-content").style.setProperty(
          "--spacing-padding-block",
          this.heightSection + "px"
        );
    }
    init() {
      (this.distance =
        this.querySelector(".js-marquee-item").offsetWidth),
        (this.speed = this.dataset.speed),
        this.style.setProperty(
          "--marquee-duration",
          this.distance / this.speed + "s"
        );
    }
  }
  customElements.define("marquee-content", Marquee);
}


if (!customElements.get("custom-accordion")) {
  customElements.define(
    "custom-accordion",
    class CustomAccordion extends HTMLElement {
      constructor() {
        super();

        this.isFaq = this.querySelector(".faq-item");
        this.isBlog = this.querySelector(".blog-category-item");

        if (this.isFaq) {
          this.item = this.querySelector(".faq-item");
          this.panel = this.querySelector(".faq-item-content");
          this.trigger = this.item; // ✅ whole item clickable
        }

        if (this.isBlog) {
          this.item = this.querySelector(".blog-category-item");
          this.panel = this.querySelector(".blog-subcategory-list");
          this.trigger = this.querySelector(".blog-category-toggle");
        }
      }

      connectedCallback() {
        if (!this.item || !this.panel || !this.trigger) return;

        if (this.item.classList.contains("is-open")) {
          this.panel.style.height = this.panel.scrollHeight + "px";
        }

        this.trigger.addEventListener("click", (e) => {
          e.preventDefault();
          this.toggle();
        });
      }

      toggle() {
        this.item.classList.contains("is-open")
          ? this.close()
          : this.open();
      }

      open() {
        this.item.classList.add("is-open");
        this.panel.style.height = "0px";

        requestAnimationFrame(() => {
          this.panel.style.height = this.panel.scrollHeight + "px";
        });
      }

      close() {
        this.panel.style.height = this.panel.scrollHeight + "px";
        this.item.classList.remove("is-open");

        requestAnimationFrame(() => {
          this.panel.style.height = "0px";
        });
      }
    }
  );
}


 

if (!customElements.get("open-side-bar")) {
  customElements.define(
    "open-side-bar",
    class OpenSideBar extends HTMLElement {
      constructor() {
        super();
        this.sidebar = document.querySelector(".main-blog-sidebar");
      }

      connectedCallback() {
        if (!this.sidebar) return;

        this.addEventListener("click", (e) => {
          e.preventDefault();
          this.toggle();
        });
      }

      toggle() {
        const isOpen = this.sidebar.classList.toggle("is-open");

        // 🔥 body blur control
        document.body.classList.toggle("sidebar-open", isOpen);
      }
    }
  );
}

if (!customElements.get("side-bar-close")) {
  customElements.define(
    "side-bar-close",
    class SideBarClose extends HTMLElement {
      constructor() {
        super();
        this.sidebar = document.querySelector(".main-blog-sidebar");
      }

      connectedCallback() {
        if (!this.sidebar) return;

        this.addEventListener("click", (e) => {
          e.preventDefault();
          this.close();
        });
      }

      close() {
        this.sidebar.classList.remove("is-open");

        // 🔥 body blur remove
        document.body.classList.remove("sidebar-open");
      }
    }
  );
}



if (!customElements.get("password-toggle")) {
  customElements.define(
    "password-toggle",
    class PasswordToggle extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector('input[type="password"], input[type="text"]');
        this.showIcon = this.querySelector(".password-toggle.show");
        this.hideIcon = this.querySelector(".password-toggle.hide");
      }

      connectedCallback() {
        if (!this.input || !this.showIcon || !this.hideIcon) return;

        this.showIcon.addEventListener("click", () => this.show());
        this.hideIcon.addEventListener("click", () => this.hide());
      }

      show() {
        this.input.type = "text";
        this.showIcon.style.display = "none";
        this.hideIcon.style.display = "block";
      }

      hide() {
        this.input.type = "password";
        this.hideIcon.style.display = "none";
        this.showIcon.style.display = "block";
      }
    }
  );
}







document.addEventListener("DOMContentLoaded", function() {
  const loginForm = document.querySelector(".login-form");
  const resetForm = document.querySelector(".reset-password-form");
  const forgotLink = document.querySelector(".forgot-password-link");
  const cancelReset = document.querySelector(".cancel-reset");
  const accountSubText = document.querySelector(".account-sub-text"); 

   if(forgotLink != null){
  forgotLink.addEventListener("click", function(e) {
    e.preventDefault();
    loginForm.style.display = "none";      
    resetForm.style.display = "block";     
    if(accountSubText) accountSubText.style.display = "none"; 
  });
   }


  // Cancel clicked
     if(cancelReset != null){

        cancelReset.addEventListener("click", function() {
    resetForm.style.display = "none";       
    loginForm.style.display = "block";      
    if(accountSubText) accountSubText.style.display = "block"; 
  });


     }

});
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.regular_pag-content-wrap p').forEach(p => {
      if (!p.textContent.replace(/\u00A0/g, '').trim()) {
        p.style.display = 'none';
      }
    });
  });


 document.querySelectorAll('.copy-link-btn').forEach(button => {
  button.addEventListener('click', function () {

    const link = this.dataset.link;

    navigator.clipboard.writeText(link).then(() => {

      this.classList.add('copied');

      const text = this.querySelector('.copy-text');
      if(text){
        text.textContent = "Copied!";
      }else{
        this.innerHTML = '<span class="icon">✔</span>Copied!';
      }

      setTimeout(() => {
        this.classList.remove('copied');
        this.innerHTML = `
        <span class="icon">
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none">
        <path d="M7.5 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03969 21 7.15979 21 9.4V16.5M6.2 21H14.3C15.4201 21 15.9802 21 16.408 20.782C16.7843 20.5903 17.0903 20.2843 17.282 19.908C17.5 19.4802 17.5 18.9201 17.5 17.8V9.7C17.5 8.57989 17.5 8.01984 17.282 7.59202C17.0903 7.21569 16.7843 6.90973 16.408 6.71799C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2C5.0799 6.5 4.51984 6.5 4.09202 6.71799C3.71569 6.90973 3.40973 7.21569 3.21799 7.59202C3 8.01984 3 8.57989 3 9.7V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        </span> Click to copy`;
      }, 2000);

    });

  });
});